import(/* webpackMode: "eager", webpackExports: ["ComparisonTable"] */ "/app/apps/todoist-landing-pages/app/[locale]/pricing/components/comparison-table/comparison-table.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Cta"] */ "/app/apps/todoist-landing-pages/app/[locale]/pricing/components/cta/cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Intro"] */ "/app/apps/todoist-landing-pages/app/[locale]/pricing/components/intro/intro.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Plans"] */ "/app/apps/todoist-landing-pages/app/[locale]/pricing/components/plans/plans.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/[locale]/pricing/components/pricing-team.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["ViewItemAnalytics"] */ "/app/apps/todoist-landing-pages/app/[locale]/pricing/components/view-item/view-item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/app/apps/todoist-landing-pages/app/components/marketist.tsx");
